export type UnreadPreviewRow = {
  conversationId: string;
  preview: string;
  lastMessageAt: string;
  unreadCount: number;
  isOutbound: boolean;
};

export type UnreadPreviewPatch = {
  conversationId: string;
  preview: string;
  lastMessageAt: string;
  unreadCount: number;
  isOutbound: boolean;
  stillUnread: boolean;
};

/**
 * Atualiza uma prévia que já está na lista. Conversa nova não lida precisa
 * de uma busca (falta o nome). O restante não volta ao banco.
 */
export function patchKnownUnreadPreview<T extends UnreadPreviewRow>(
  current: readonly T[],
  patch: UnreadPreviewPatch,
): { next: T[]; applied: boolean; membershipDelta: number } {
  const index = current.findIndex((row) => row.conversationId === patch.conversationId);

  if (!patch.stillUnread) {
    if (index === -1) return { next: current as T[], applied: true, membershipDelta: 0 };
    const next = current.filter((row) => row.conversationId !== patch.conversationId);
    return { next, applied: true, membershipDelta: -1 };
  }

  if (index === -1) {
    return { next: current as T[], applied: false, membershipDelta: 0 };
  }

  const existing = current[index];
  const updated = {
    ...existing,
    preview: patch.preview,
    lastMessageAt: patch.lastMessageAt,
    unreadCount: patch.unreadCount,
    isOutbound: patch.isOutbound,
  } as T;
  const next = current.slice();
  next[index] = updated;
  return { next, applied: true, membershipDelta: 0 };
}
